import { PlusIcon } from '@heroicons/react/solid';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  PoliciesActions,
  useProductSelector,
} from '@wajeez-web/stores/product';
import { useAppDispatch } from '@wajeez-web/stores/base';
import { useEffectCancelled } from '@wajeez-web/components/helpers';
import { PageLayoutsContainer } from '@wajeez-web/components/layouts';
import { WajeezCard, WajeezList } from '@wajeez-web/components/list-builder';
import { Identity } from '@wajeez-web/core/api-base';
import { Button } from '@wajeez-web/components/ui';

const PoliciesPage = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const data = useProductSelector((s) => s.policies.data);
  const loadList = useProductSelector((s) => s.policies.status === 'loading');
  const { t } = useTranslation();

  useEffectCancelled((canceller) => {
    getData(canceller);
    return () => {
      return;
    };
  }, []);

  const getData = (canceller: AbortController) => {
    dispatch(PoliciesActions.getAllPoliciesAsync());
  };

  const deleteItem = async (id: number) => {
    await dispatch(PoliciesActions.deletePolicyAsync(id));
    getData(new AbortController());
  };

  return (
    <div>
      <PageLayoutsContainer
        title="Policies"
        withoutRightPadding={true}
        endSideComponent={[
          {
            element: (
              <Link to={`create`}>
                <Button
                  title={'Add New Policy'}
                  Icon={PlusIcon}
                  onClick={() => {
                    return;
                  }}
                  bg="primary"
                  color="white"
                />
              </Link>
            ),
            permission: ['47.0'],
            // permission: AdminSystemPermissions.policies.add,
          },
        ]}
        breadCrumbsLinks={[{ title: 'Policies' }]}
      >
        {
          <div className="  pe-8">
            {
              <WajeezList
                isLoading={loadList}
                gridItems={3}
                data={data}
                keyExtractor={(item) => item.id + ''}
                renderItem={(item) => (
                  <WajeezCard
                    badge={
                      item.policyType != undefined
                        ? Identity.PolicyType[item.policyType]
                        : undefined
                    }
                    title={item.title}
                    headerActions={[
                      {
                        type: 'link',
                        label: 'Details',
                        link: `${item.id}`,
                      },
                      {
                        type: 'action',
                        label: 'Delete',
                        onClick: () => {
                          !!item.id && deleteItem(item.id);
                        },
                      },
                    ]}
                  />
                )}
                containerType="cards"
                getData={getData}
              />
            }
          </div>
        }
      </PageLayoutsContainer>
    </div>
  );
};

export default PoliciesPage;
